import IMessage from "../models/IMessage";

export default class UserStore {
  public data: any = null;

  getEmail(): string {
    if (!this.data) {
      return '';
    }
    return this.data.email;
  }

  getFullname(): string {
    if (!this.data) {
      return '';
    }
    return this.data.full_name;
  }

  hasSeenMessage(message: IMessage): boolean {
    const email = this.getEmail();
    return message.to.some(u => u.email === email && u.seen_at) || message.cc.some(u => u.email === email && u.seen_at);
  }
}
